
/*
**  TagCommander event hooks.
**  tagCommanderEvents.js: Åkallar dessa events vid laddning.
**  Dynamisk åkallning sker genom vanlig import i react-komponenterna.
*/

// an observer lets us execute javascript when the observed element is inside the observers viewport.


export const tcEventProductListView = (data, tagCommanderElement) => {
    if (window.tC == undefined) return
    
    const jsonTcProductListView =  parseData(data)

    if (jsonTcProductListView == null) {
        console.warn("Can not connect tcEventProductListView because jsonTcProductListView is null")
        return
    }
    
    // If we have access to a connected element, we only want to trigger the event if the element is in the viewport.
    if (tagCommanderElement) {
        const windowObserver = new IntersectionObserver(entries =>  {
            entries.forEach(entry => {             
                if (entry.isIntersecting) {
                    window.tC.event.productListView(this, jsonTcProductListView);
                    windowObserver.unobserve(tagCommanderElement)
                }
            })
        }, { threshold: 0.25 })

        windowObserver.observe(tagCommanderElement)
    }
    else {
        window.tC.event.productListView(this, jsonTcProductListView);
    }
}

export const tcEventProductClick = (data, tagCommanderElement) => {
    if (window.tC == undefined) return

    const jsonTcProductclick =  parseData(data)

    tagCommanderElement.addEventListener('click', (e) => {       
        tcEventProductClickEvent(jsonTcProductclick)
    })
}

export const tcEventProductClickEvent = (product, listName, index = null) => {
    if (window.tC == undefined) return

    if (typeof product === "string") {
        product = JSON.parse(product)
    }

    const data = {
        'position' : product.position || index + 1,
        'productListName' : listName,
        'productID' : product.productID || product.product_id,
        'productName' : product.productName || product.product_name,
        'marketingCategory': product.marketingCategory || product.marketing_category,
        'marketingSubcategory': product.marketingSubcategory || product.marketing_subcategory,
        'productType' : product.productType || product.product_type,
        'productAvailability': product.productAvailability || product.product_availability,
        'productPrice' : product.productPrice || product.product_price,
        'productCurrency' : product.productCurrency || product.product_currency,
        'productBrand' : product.productBrand || product.product_brand,
        'productLabel': product.productLabel || product.product_label
    }

    const jsonTcProductclick =  parseData(data)

    window.tC.event.productClick(this, jsonTcProductclick);
}


export const dataTrackingAddToCart = (updatedCart, addedProductArticleNumber, addedProductQuantity) => {
    let addedProduct = updatedCart.orderRows.find(product => product.articleNumber === addedProductArticleNumber)
    if (addedProduct == undefined) {
        // If we cant find the product from the articleNumber, then addedProductArticleNumber is the rowSystemId
        addedProduct = updatedCart.orderRows.find(product => product.rowSystemId === addedProductArticleNumber) 
    }

    if (addedProduct == undefined) return // If we still cant find the product, then it is probably a delete. TODO Add delete event tracking?

    const pageType = window.tc_vars['page_type'] // inherits from page
    const addedProductID = addedProduct.product_id
    const addedProductName = addedProduct.name
    const addedProductMarketingCategory = addedProduct.marketing_category
    const addedProductMarketingSubcategory = addedProduct.marketing_subcategory
    const addedProductType = addedProduct.product_type
    const addedProductAvailability = addedProduct.product_availability
    const addedProductPrice = parseFloat(addedProduct.product_price) | 0
    const addedProductCurrency = addedProduct.product_currency
    const addedProductBrand = addedProduct.product_brand

    // GA4
    dataLayer.push({ ecommerce: null })
    dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
            currency: addedProductCurrency,
            value: parseFloat(updatedCart.cart_grandtotal | 0),
            items: updatedCart.cart_GAitems
        }
    })

    if (window.tC == undefined) return

    // TagCommander
    window.tC.event.clickAddToCart(this, {
        pageType,
        productID: addedProductID,
        productName: addedProductName,
        marketingCategory: addedProductMarketingCategory,
        marketingSubcategory: addedProductMarketingSubcategory,
        productType: addedProductType,
        productAvailability: addedProductAvailability,
        productPrice: addedProductPrice,
        productQuantity: addedProductQuantity,
        productCurrency: addedProductCurrency,
        productBrand: addedProductBrand
    })
}

export const dataTrackingRemoveFromCart = (updatedCart, removedProductArticleNumber, removedProductQuantity) => {
    // TODO Implement
}

export const tcEventClickRemoveFromCart = (data, tagCommanderElement) => {
    if (window.tC == undefined) return

    const jsonTcProductclick =  parseData(data)
    tagCommanderElement.addEventListener('click', (e) => {
        
        tcEventClickRemoveFromCartEvent(jsonTcProductclick)
    })
}
export const tcEventClickRemoveFromCartEvent = (order) => {
    if (window.tC == undefined) return
    const data = {
        'pageType': window.tc_vars['page_type'], // inherits from page
        'productID' : order.product_id,
        'productName' : order.product_name,
        'marketingCategory':order.marketing_category,
        'marketingSubcategory': order.marketing_subcategory,
        'productType' : order.product_type,
        'productAvailability': order.product_availability,
        'productPrice' : order.product_price,
        'productQuantity' : order.quantity,
        'productCurrency' : order.product_currency,
        'productBrand' : order.product_brand
    } 
    window.tC.event.clickRemoveFromCart(this, data);
}


export const tcEventDocumentationDownload = (data, tagCommanderElement) => {
    if (window.tC == undefined) return

    const jsonTcDownloadclick =  parseData(data)

    tagCommanderElement.addEventListener('click', (e) => {
        window.tC.event.documentationDownload(this, jsonTcDownloadclick);
    })
}

export const tcEventFAQ = (faqTopic, tagCommanderElement) => {
    tagCommanderElement.addEventListener('click', (e) => {
        let {expanded} = tagCommanderElement.dataset
        if(expanded === 'false'){
            window.tC.event.FAQ(this, {
                faqTopic: faqTopic
            });
        }
    })
}

export const tcEventClickProductTab = (productTab, tagCommanderElement) => {
    tagCommanderElement.addEventListener('click', (e) => {
        window.tC.event.clickProductTab(this, {
            'tab': productTab
        });
    })
}

export const tcEventFacetedSearch = (filterName, filterCriteria) => {
    if (window.tC == undefined) return

    window.tC.event.facetedSearch(this,{
        'facetFilterName': filterName,
        'facetFilterCriteria': filterCriteria
    });
}

export const tcEventClickSort = (tagCommanderElement) => {
    if (window.tC == undefined) return

    tagCommanderElement.addEventListener('change', (e) => {
        let optionText = tagCommanderElement.options[tagCommanderElement.selectedIndex].innerHTML
        tcEventClickSortEvent(optionText)
    })
}
export const tcEventClickSortEvent = (optionText) => {
    if (window.tC == undefined) return

    window.tC.event.clickSort(this,{
        'sortName': optionText
    });
}

export const tcEventClickBuyOnlineRetailerLogo = (data, tagCommanderElement) => {
    if (window.tC == undefined) return

    const jsonTcClickBuyOnlineRetailerLogo =  parseData(data)

    tagCommanderElement.addEventListener('click', (e) => {
        window.tC.event.buyOnlineRetailerLogo(this, jsonTcClickBuyOnlineRetailerLogo);
    })
}

export const tcEventClickOnlineButton = (data, tagCommanderElement) => {
    if (window.tC == undefined) return

    const jsonTcClickBuyOnlineButton =  parseData(data)

    tagCommanderElement.addEventListener('click', (e) => {
        window.tC.event.buyOnlineButton(this, jsonTcClickBuyOnlineButton);
    })
}


export const tcEventClickSeeRecipe = (data, tagCommanderElement) => {
    if (window.tC == undefined) return

    const jsonTcRecepieclick =  parseData(data)

    tagCommanderElement.addEventListener('click', (e) => {
        tC.event.clickseeRecipe(this, jsonTcRecepieclick);
    })
}

export const tcBasketPromoCodeSuccess = ({ cart }) => {
    const { cart_subtotal, cart_vat, cart_grandtotal, cart_GAitems, cart_currency, voucher_code, voucher_discount } = cart

    // TagCommander
    tc_vars['cart_subtotal'] = cart_subtotal;
    tc_vars['cart_total'] = cart_grandtotal;
    tc_vars['voucher_code'] = voucher_code;
    tc_vars['voucher_discount'] = voucher_discount;

    // GA - we may not need to update begin_checkout on promo code success
    // window.dataLayer.push({ ecommerce: null });
    // window.dataLayer.push({
    //     event: "begin_checkout",
    //     ecommerce: {
    //         'value': parseFloat(cart_grandtotal | 0),
    //         'tax': parseFloat(cart_vat | 0),
    //         'currency': cart_currency,
    //         'items': cart_GAitems,
    //     }
    // });

    // TagCommander
    if (window.tC == undefined) return
    
    window.tC.event.clickBasketPromoCode(this, {
        'voucherOperation': '',
        'voucherCode': voucher_code
    });
}
export const tcBasketPromoCodeError = ({ cart }) => {
    const { cart_subtotal, cart_vat, cart_grandtotal, cart_GAitems, cart_currency, voucher_discount } = cart

    // TagCommander
    tc_vars['cart_subtotal'] = cart_subtotal;
    tc_vars['cart_total'] = cart_grandtotal;
    tc_vars['voucher_code'] = "";
    tc_vars['voucher_operation'] = "";
    tc_vars['voucher_discount'] = voucher_discount;

    // GA
    // window.dataLayer.push({ ecommerce: null });
    // window.dataLayer.push({
    //     event: "begin_checkout",
    //     ecommerce: {
    //         'value': parseFloat(cart_grandtotal | 0),
    //         'tax': parseFloat(cart_vat | 0),
    //         'currency': cart_currency,
    //         'items': cart_GAitems,
    //     }
    // });
}

export const tcEventClickCheckoutPay = () => {
    if (window.tC == undefined) return


}
export const tcEventClickCheckoutPayEvent = () => {
    if (window.tC == undefined) return

    window.tC.event.clickCheckoutPay(this, {});
}

export const tcEventClickNavigationEvent = (data) => {
    if (window.tC == undefined) return

    window.tC.event.clickNavigation(this,{
            'navLevel': data
    });
}

export const tcEventClickNavigation = (data, tagCommanderElement) => {
    if (window.tC == undefined) return

    tagCommanderElement.addEventListener('click', (e) => {
        window.tC.event.clickNavigation(this,{
            'navLevel': data
        });
    })
}

export const tcEventClickBrandCornerEvent = (pos, category) => {
    if (window.tC == undefined) return

    window.tC.event.clickBrandCorner(this,{
        'productCategory': category,
        'positionLabel': pos
    });
}

export const tcEventClickSearchEvent = (data) => {
    if (window.tC == undefined) return

    window.tC.event.search(this,{
            'request': data
    });
}

export const tcEventClickSearchSuggestionEvent = (searchQuery, clickedSearchResult) => {
    if (window.tC == undefined) return

    window.tC.event.searchSuggestion(this,{
            'request': searchQuery,
            'type': clickedSearchResult
    });
}

export const tcEventClickExitLink = (tagCommanderElement) => {
    if (window.tC == undefined) return

    let isDownloadAppLink = false
    const socialSites = [ 
        'https://www.facebook', 'https://facebook', 
        'https://www.instagram', 'https://instagram',
        'https://www.youtube', 'https://youtube',
        'https://www.linkedin', 'https://linkedin'  
    ]
    const appDownloadSitesAndroid = [
        'https://www.play.google.com', 'https://play.google.com',
    ]
    const appDownloadSitesIOS = [
        'https://www.apps.apple.com', 'https://apps.apple.com',
    ]   
    const { href } = tagCommanderElement
    
    let linkType = socialSites.find(link => href.includes(link)) ? 'Social' : 'others'
    appDownloadSitesAndroid.find(link => {
        if (href.includes(link)) {
            isDownloadAppLink = true
            linkType = 'Android'
        }
    })
    appDownloadSitesIOS.find(link => {
        if (href.includes(link)) {
            isDownloadAppLink = true
            linkType = 'iOS'
        }
    })

    tagCommanderElement.addEventListener('click', (e) => {
        if (isDownloadAppLink) {
            window.tC.event.clickdownloadApp(this,{
                'appType': linkType
            });
        }
        else {
            window.tC.event.exitLink(this,{
                'linkType': linkType,
                'linkURL': href
            }); 
        }
    })       
}

export const tcEventVirtualView = (pageType) => {
    if (window.tC == undefined) return

    tc_vars['page_type'] = pageType;
    
    window.tC.event.virtualView(this);
}

// Helper functions
function parseData(data) {
    if (typeof data === "string")
        return JSON.parse(data);

    return data
}